import React from "react"
import Svg, { Path } from "react-native-svg"

const ApproveIcon = ({ width = 21, height = 20, color = "#0F8040", ...props }) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <Path
      d="M17.377 5.63l-8.751 8.752-4.376-4.375"
      stroke={color}
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

export default ApproveIcon
